// extracted by mini-css-extract-plugin
export default {"superHead":"SuperTyping_superHead__9AWul","superpower":"SuperTyping_superpower__U-oHh","blinkingCursor":"SuperTyping_blinkingCursor__6is5M","blink":"SuperTyping_blink__1EUNx"};